import React from 'react';
import 'twin.macro';
import { ReunionWithCategory } from 'types/reunions';
import { PlannerEvent } from 'containers/Dashboard/PlannerEvents/PlannerEvent';
import _orderBy from 'lodash-es/orderBy';
import { useCJConfigurationDisplay } from 'containers/CahierJournal/useCJConfigurationDisplay';

interface Props {
  day: Date;
  plannerEvents: ReunionWithCategory[];
  className?: string;
}

export function PlannerEvents(props: Props) {
  const { hideEvents } = useCJConfigurationDisplay();
  if (hideEvents) {
    return null;
  }
  const eventsOfTheDay = props.plannerEvents.filter(event => {
    const eventDate = new Date(event.date);
    return eventDate.getDate() === props.day.getDate();
  });
  if (eventsOfTheDay.length === 0) {
    return null;
  }
  return (
    <div tw="space-y-2 mb-2" className={props.className}>
      {_orderBy(
        eventsOfTheDay,
        [ev => (ev.lastingInMinutes === -1 ? 0 : 1), 'date'],
        ['asc', 'asc'],
      ).map(ev => (
        <PlannerEvent key={ev.id} reunion={ev} />
      ))}
    </div>
  );
}
